import { useState } from "react";


export const useWorkforceStep = ({ defaultValues = {}, totalSteps = 3 } = {}) => {
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState(defaultValues);

  const nextStep = (data) => {
    if (data) setFormData((prev) => ({ ...prev, ...data }));
    setActiveStep((prev) => Math.min(prev + 1, totalSteps - 1));
  };

  const previousStep = () => {
    setActiveStep((prev) => Math.max(prev - 1, 0));
  };

  const resetSteps = () => {
    setActiveStep(0);
    setFormData(defaultValues);
  };

  const finishStep = (callback) => {
    if (typeof callback === "function") callback(formData);
  };

  return {
    activeStep,
    formData,
    nextStep,
    previousStep,
    resetSteps,
    finishStep,
  };
};
